import React from "react";

import "./ReportHeaderLayout.css";
import "./ReportPrintDocument.css";

export function ReportRule({ thin = false, variant = "print" }) {
  const prefix = variant === "print" ? "erp" : "er";

  return <hr className={thin ? `${prefix}-rule-thin` : `${prefix}-rule`} />;
}
